import { X } from "lucide-react";
import Modal from "../Shared/Modal";
import BilingualText from "./BilingualText";
import { embedUrlFor } from "./config";
import { localizedText } from "./localizedText";
import type { ActiveClip, RoadmapLanguage } from "./types";

type CredentialVideoModalProps = {
  clip: ActiveClip | null;
  onClose: () => void;
  language: RoadmapLanguage;
};

const CredentialVideoModal = ({
  clip,
  onClose,
  language,
}: CredentialVideoModalProps) => (
  <Modal
    isOpen={!!clip}
    closeModal={onClose}
    className="!max-w-4xl overflow-hidden !rounded-[24px] !p-0"
  >
    {clip && (
      <div className="bg-primary text-white">
        <div className="flex items-start justify-between gap-4 px-5 py-4 sm:px-6">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#ffb59e]">
              {clip.code}
            </p>
            <h3 className="mt-1 text-lg font-bold sm:text-xl">
              <BilingualText value={clip.title} language={language} />
            </h3>
          </div>
          <button
            type="button"
            aria-label={language === "ar" ? "إغلاق الفيديو" : "Close video"}
            onClick={onClose}
            className="flex size-10 shrink-0 items-center justify-center rounded-full bg-white/10 transition hover:bg-white/20"
          >
            <X size={18} />
          </button>
        </div>

        <div className="aspect-video w-full bg-black">
          <iframe
            key={`${clip.code}-${clip.segment.start}`}
            title={localizedText(clip.title, language)}
            className="h-full w-full border-0"
            src={embedUrlFor(clip.segment)}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    )}
  </Modal>
);

export default CredentialVideoModal;
